import createStore from "../../../../../../AppCustomStateManagement/createStore";

// Library interfaces
interface IActionScreen {
  definedVariablesData: any;
}

interface IActionScreenAction {
  type: any;
  payload?: any;
}

const initialState = {
  definedVariablesData: {},
};

const reducer = (store: IActionScreen, action: IActionScreenAction) => {
  switch (action.type) {
    case "RESET_STORE":
      store = { ...initialState };
      return store;
    case "SET_DEFINED_VARIABLES":
      store = { ...store, definedVariablesData: action.payload };
      return store;
    default:
      return store;
  }
};

export const [
  useActionScreenDefineProducedProductParameterizedVariableValuesStore,
  dispatchActionScreenDefineProducedProductParameterizedVariableValuesStore,
] = createStore(initialState, reducer);
